import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { AppConfig, ConfigService } from 'app/services/api/config.service';

const DEFAULT_CONFIG: AppConfig = {
  logoGeneralUrl: 'assets/images/logo/original_m.png',
  logoSinTextoUrl: 'assets/images/logo/escudo_m.png',
  faviconUrl: null,
  logoTurnoUrl: null,
  iconoAvisosUrl: null,
  telefonoEmergencia: null,
  telefonoAtencion: null,
  tamanoPassword: 8,
  requiereCaracteresEspeciales: true,
  requiereMayusculas: true,
  requiereNumeros: true,
  maxPeticionesBloqueoWeb: null,
  maxPeticionesBloqueoWhats: null,
  mensajeIntroTitulo: null,
  mensajeIntroDescripcion: null,
};

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private document = inject(DOCUMENT);
  private configService = inject(ConfigService);
  private _config$ = new BehaviorSubject<AppConfig>(DEFAULT_CONFIG);

  get config$() {
    return this._config$.asObservable();
  }

  /** Lectura síncrona de la configuración actual (útil para validadores reactivos). */
  get currentConfig(): AppConfig {
    return this._config$.value;
  }

  setConfig(config: AppConfig): void {
    this._config$.next(config);
    this.applyFaviconAndSplash(config);
  }

  init(): Promise<void> {
    return new Promise((resolve) => {
      this.configService.getConfig().subscribe({
        next: (config) => {
          this._config$.next(config);
          this.applyFaviconAndSplash(config);
          resolve();
        },
        error: (err) => {
          console.error('No se pudo cargar la configuración de apariencia, se usarán los valores por defecto.', err);
          resolve();
        },
      });
    });
  }

  private applyFaviconAndSplash(config: AppConfig): void {
    if (config.faviconUrl) {
      this.document.querySelectorAll<HTMLLinkElement>('link[rel="icon"]')
        .forEach((link) => (link.href = config.faviconUrl as string));
    }
    if (config.logoSinTextoUrl) {
      const splashImg = this.document.querySelector<HTMLImageElement>('fuse-splash-screen img');
      if (splashImg) {
        splashImg.src = config.logoSinTextoUrl;
      }
    }
  }
}
